<template>
<div class="page-box">
    <!-- style="position:fixed; top:0px;" -->
    <ctrl-box class="ctrl-box" :data="{}" v-reheight="ctrlBoxHeightChanged">
        <template>
            <div class="xgroup" >
                <views-pop title="订单管理" type="1" @load="viewChange" @change="viewChange"/>
                <!-- <el-link :underline="false" style="font-weight:bold;">
                    <div class="wrap" >
                        <span class="txt" >{{msg('订单管理')}}</span>      
                    </div>                
                </el-link> -->
            </div>
            <div class="xgroup">
                <el-link :underline="false" @click="getData(true)">
                    <div class="wrap" >
                        <icon-svg icon-class="icon-shuaxin1" font-size="27px;"/>
                        <span class="txt" >{{msg('刷新')}}</span>      
                    </div>                
                </el-link>
                <el-link :underline="false" @click="showQuery = !showQuery">
                    <div class="wrap" >
                        <icon-svg icon-class="icon-search" font-size="27px;"/>
                        <span class="txt" >{{msg('搜索')}}</span>      
                    </div>                
                </el-link>
                <el-link :underline="false" @click="doSummary()">
                    <div class="wrap" >
                        <icon-svg icon-class="icon-zongshu" font-size="27px;"/>
                        <span class="txt">{{msg('统计')}}</span>
                    </div>
                </el-link>
                <el-link :underline="false" @click="buy()">
                    <div class="wrap" >
                        <icon-svg icon-class="icon-huowucaigou" font-size="27px;"/>
                        <span class="txt">{{msg('采购')}}</span>
                    </div>            
                </el-link>
                <order-ctrl title="同步" width="100px" icon="icon-tongbudingdan">
                    <template>
                        <el-link class="ctrl-item" :underline="false" @click="doTrackExpress" v-if="hasPermissions('stock:batchSendOrde')">
                            <icon-svg icon-class="icon-kuaiditongbu" font-size="20px;"/>
                            <span>{{msg('同步快递')}}</span>
                        </el-link>
                        <el-link class="ctrl-item" :underline="false" @click="doSyncOrder" v-if="hasPermissions('stock:syncOrder')">
                            <icon-svg icon-class="icon-tongbudingdan" font-size="22px;"/>
                            <span class="txt">{{msg('同步订单')}}</span>
                        </el-link>
                    </template>
                </order-ctrl>
                <el-link :underline="false" @click="updatePurchaseCode()">
                    <div class="wrap" >
                        <icon-svg icon-class="icon-procurement-copy" font-size="27px;"/>
                        <span class="txt">{{msg('采购单号')}}</span>
                    </div>            
                </el-link>
                <el-link :underline="false" @click="updateInnerExpCode()">
                    <div class="wrap" >
                        <icon-svg icon-class="icon-kuaidiguanli" font-size="27px;"/>
                        <span class="txt">{{msg('快递单号')}}</span>
                    </div>            
                </el-link>

                <el-link :underline="false" v-if="hasPermissions('stock:stockSelect')" @click="selectStock()">
                    <div class="wrap" >
                        <icon-svg icon-class="icon-huowuzhuanji" font-size="27px;"/>
                        <span class="txt">{{msg('货物转寄')}}</span>
                    </div>            
                </el-link>
                <order-ctrl title="撤清移删" width="100px" icon="icon-fabutongzhi1">
                    <template>
                        <el-link class="ctrl-item" :underline="false" @click="doDeletePurchase()">
                            <i class="el-icon-error font22" style="color: red; margin-top: 4px;margin-bottom: 6px;"></i>
                            <span class="txt">{{msg('撤销采购')}}</span>
                        </el-link>
                        <el-link class="ctrl-item" :underline="false" @click="doDeleteInnerCode()">
                            <icon-svg icon-class="icon-piliangshanchu" font-size="22px;"/>
                            <span class="txt">{{msg('清除快递')}}</span>
                        </el-link>
                        <el-link class="ctrl-item" :underline="false" @click="changeOrderPlatform()">
                            <icon-svg icon-class="icon-quxiaohuifu" font-size="22px;"/>
                            <span class="txt">{{msg('移除订单')}}</span>
                        </el-link>
                        <el-link class="ctrl-item" :underline="false" @click="doDeleteStock()" v-if="hasPermissions('stock:deleteAll')">
                            <icon-svg icon-class="icon-shanchu1" font-size="22px;"/>
                            <span class="txt">{{msg('删除订单')}}</span>
                        </el-link>
                        <el-link class="ctrl-item" :underline="false" @click="doCancelStock()" v-if="hasPermissions('stock:cancel')">
                            <icon-svg icon-class="icon-shanchu1" font-size="22px;"/>
                            <span class="txt">{{msg('确认取消')}}</span>
                        </el-link>
                    </template>
                </order-ctrl>
                <el-link :underline="false" @click="kuaidi()">
                    <div class="wrap" >
                        <icon-svg icon-class="icon-kuaidihuowu" font-size="27px;"/>
                        <span class="txt">{{msg('快递货物')}}</span>
                    </div>
                </el-link>
                <order-ctrl title="获取面单" width="100px" icon="icon-cangchutiedan">
                    <template>
                        <el-link class="ctrl-item" :underline="false" @click="doBatchSendOrderNew" v-if="hasPermissions('stock:batchSendOrde')">
                            <icon-svg icon-class="icon-yijianfahuo" font-size="22px;"/>
                            <span class="txt">{{msg('一键发货')}}</span>
                        </el-link>
                    </template>
                </order-ctrl>
                <el-dropdown @command="(cmd)=> doMarkOrderGoodType(cmd)" v-if="hasPermissions('stock:updatePkgType')">
                    <el-link :underline="false">
                        <div class="wrap" >
                            <icon-svg icon-class="icon-daidabao1" font-size="27px;" />
                            <span class="txt">{{ msg("普特货") }}</span>      
                        </div>
                    </el-link>
                        <el-dropdown-menu slot="dropdown">
                            <template v-for="item in goodTypeBtns"  >
                                <el-dropdown-item :command="item.command" :key="item.command"  v-if="hasPermissions(item.permission, 'or')">{{item.name}}</el-dropdown-item>
                            </template>
                        </el-dropdown-menu>
                </el-dropdown>
                <order-ctrl title="更新" width="100px" icon="icon-tongbudingdan">
                    <template>
                        <el-link class="ctrl-item" :underline="false" @click="doUpdateTransport">
                            <icon-svg icon-class="icon-kuaiditongbu" font-size="20px;"/>
                            <span class="txt">{{msg('运输方式')}}</span>
                        </el-link>
                        <el-link class="ctrl-item" :underline="false" @click="doUpdateCompany">
                            <icon-svg icon-class="icon-tongbudingdan" font-size="22px;"/>
                            <span class="txt">{{msg('配送方式')}}</span>
                        </el-link>
                    </template>
                </order-ctrl>
                <order-ctrl title="详情" width="100px" icon="icon-a-kuozhanicon_huaban1fuben9">
                    <template>
                        <el-link class="ctrl-item" :underline="false" @click="addDetail()">
                            <i class="iconfont icon-add font22" style="color: green;"></i>&nbsp;&nbsp;
                            <span class="txt">{{msg('新增详情')}}</span>
                        </el-link>
                        <el-link class="ctrl-item" :underline="false" @click="updateSku()">
                            <icon-svg icon-class="icon-xiugai" font-size="22px;"/>
                            <span class="txt">{{msg('sku&货号')}}</span>
                        </el-link>
                        <el-link class="ctrl-item" :underline="false" @click="deleteDetail()">
                            <i class="iconfont icon-delete font22" style="color: red;"></i>&nbsp;&nbsp;
                            <span class="txt">{{msg('删除详情')}}</span>
                        </el-link>
                        <el-link class="ctrl-item" :underline="false" @click="exportDetail()">
                            <icon-svg icon-class="icon-daochu" font-size="22px;"/>&nbsp;
                            <span class="txt">{{msg('导出详情')}}</span>
                        </el-link>
                        <el-link class="ctrl-item" :underline="false" @click="editPurchaseLink()">
                            <icon-svg icon-class="icon-xiugai" font-size="22px;"/>&nbsp;
                            <span class="txt">{{msg('修改链接')}}</span>
                        </el-link>
                    </template>
                </order-ctrl>
                
                <order-ctrl title="备注" width="100px" icon="icon-bianji1">
                    <template>
                        <el-link class="ctrl-item" :underline="false" @click="updateRemark(2)">
                            <icon-svg icon-class="icon-bianji" font-size="22px;"/>
                            <span class="txt">{{msg('货单备注')}}</span>
                        </el-link>
                        <el-link class="ctrl-item" :underline="false" @click="updateRemark(1)">
                            <icon-svg icon-class="icon-xiugai" font-size="22px;"/>
                            <span class="txt">{{msg('报单备注')}}</span>
                        </el-link>
                        <el-link class="ctrl-item" :underline="false" @click="doUpdateCost()">
                            <icon-svg icon-class="icon-chakanxiangqing1" font-size="22px;"/>
                            <span class="txt">{{msg('更新成本')}}</span>
                        </el-link>
                    </template>
                </order-ctrl>

                <order-ctrl title="打包" width="100px" icon="icon-xunilanshou">
                    <template>
                        <el-link class="ctrl-item" :underline="false" @click="doFinishPakage" v-if="hasPermissions('stock:finishPackage')">
                            <icon-svg icon-class="icon-dabaowancheng" font-size="27px;"/>
                            <span class="txt">{{msg('打包完成')}}</span>
                        </el-link>
                        <el-link class="ctrl-item" :underline="false" @click="handlePkgType('a')" v-if="hasPermissions('stock:updatePkgType')">
                            <icon-svg icon-class="icon-daidabao1" font-size="27px;"/>
                            <span class="txt">{{msg('货运代打包')}}</span>
                        </el-link>
                        <el-link class="ctrl-item" :underline="false" @click="handlePkgType('b')" v-if="hasPermissions('stock:updatePkgType')">
                            <icon-svg icon-class="icon-zhinenglihuo" font-size="27px;"/>
                            <span class="txt">{{msg('跨仓合并包')}}</span>
                        </el-link>
                    </template>
                </order-ctrl>
                
                <el-dropdown @command="(cmd)=> doPrint(cmd)" >
                    <el-link :underline="false">
                        <div class="wrap" >
                            <icon-svg icon-class="icon-dayin2" font-size="27px;" style="color: rgb(76, 170, 172);  "/>
                            <span class="txt">{{ msg("打印") }}</span>      
                        </div>
                    </el-link>
                    <el-dropdown-menu slot="dropdown">
                        <el-dropdown-item :command="1" >{{msg("打印货单") }}</el-dropdown-item>
                        <el-dropdown-item :command="3" >{{msg("自定义单") }}</el-dropdown-item>
                        <el-dropdown-item :command="4" >{{msg("货单&自定义") }}</el-dropdown-item>
                        <el-dropdown-item :command="2" >{{msg("打印面单") }}</el-dropdown-item>
                    </el-dropdown-menu>
                </el-dropdown>
<!--                 
                <column-settings v-if="allColumns" @refresh-column="refreshColumn" col-key="ORDER_VIEW_COLUMNS" :all-columns="allColumns"/>
                 -->
                <el-link slot="reference" :underline="false" @click="showViewSetting">
                    <div class="wrap" >
                        <i class="iconfont icon-guolvqi font22"></i>
                        <span class="txt">{{msg('页面布局')}}</span>
                    </div>
                </el-link>
                <el-link :underline="false" href="https://kdocs.cn/l/cgy8qWeCfbbE" target="_blank">
                    <div class="wrap" >
                        <i class="el-icon-question" style="font-size:27px; color:#80DEEA; margin-bottom:3px;padding-top:5px;"/>
                        <span class="txt" >{{msg('帮助')}}</span>      
                    </div>                
                </el-link>
            </div>
        </template>
    </ctrl-box>

    <div class="empty-fixed-box" v-bind:style="{height:emptyFixedBoxHeight}"></div>
    <!--查询区域-->
    <transition name="el-zoom-in-top">
        <query-box :query="query" v-show="showQuery" labelWidth="80px">
            <template v-slot:default="scope"  v-if="queries">

                <el-form-item v-for="q in queries" :key="q.field" :label="q.title">
                    <el-input v-if="q.type == 'input'" size="mini" clearable 
                        v-model="scope.query[q.field]" 
                        :type="q.operator == 3 ? 'textarea': 'input'" 
                    />
                    <el-select v-if="q.type == 'selector' || q.type == 'selectors'" size="mini" clearable 
                        v-model="scope.query[q.field]" 
                        :multiple = "q.type == 'selectors'"
                    >
                        <el-option v-for="d in getDicts(q.operator)" 
                            :key="d.value" :label="d.label" :value="d.value">
                        </el-option>
                    </el-select>
                    <el-date-picker v-if="q.type == 'datetimerange'" clearable 
                        v-model="scope.query[q.field]" value-format="yyyy-MM-dd HH:mm:ss"
                        type="datetimerange"
                        range-separator="至"
                        start-placeholder="开始日期"
                        end-placeholder="结束日期">
                    </el-date-picker>
                    <el-date-picker v-if="q.type == 'daterange'" clearable 
                        v-model="scope.query[q.field]" value-format="yyyy-MM-dd"
                        type="daterange"
                        range-separator="至"
                        start-placeholder="开始日期"
                        end-placeholder="结束日期">
                    </el-date-picker>
                </el-form-item>

                <span style="margin-left:12px;">
                    <el-checkbox v-model="isInventory" @change="getInventory">查看库存</el-checkbox>
                </span>
                <span style="margin-left:12px;">
                    <el-checkbox v-model="scope.query.lockData">锁定页面</el-checkbox>
                </span>
                <el-row>
                    <el-button type="primary" icon="el-icon-search" @click="getData(true)" size="mini">{{msg('搜索')}}</el-button>
                    <el-button icon="el-icon-refresh" size="mini" @click="reset" >{{msg('重置')}}</el-button>
                </el-row>
            </template>
        </query-box>
    </transition>
    
    <div class="table-wrap">
        <div class="nav-tag">
            <el-tag :effect="query.statusStr==='13'?'dark':'plain'" @click="doNav('13')">待备货</el-tag>
            <el-tag :effect="query.statusStr==='15'?'dark':'plain'" @click="doNav('15')">备货中</el-tag>
            <el-tag :effect="query.statusStr==='20'?'dark':'plain'" @click="doNav('20')">待打包</el-tag>
            <el-tag :effect="query.statusStr==='23,25'?'dark':'plain'" @click="doNav('23,25')">打包中</el-tag>
            <el-tag :effect="query.statusStr==='79,80'?'dark':'plain'" @click="doNav('79,80')">取消单</el-tag>
            <el-tag :effect="query.statusStr=='-1'?'dark':'plain'" @click="doNav('-1')">全部</el-tag>
        </div>
        <vxe-grid ref="dataTable" class="data-table" :height="docHeight"  
            resizable border="full"
            highlight-current-row highlight-hover-column highlight-current-column
            show-overflow show-header-overflow 
            :data="datas"
            size="mini"
            :columns="columns"
            @cell-click="clickRow"
            :checkbox-config="{highlight:true, trigger: 'cell'}"
            :mergeCells="mergeCells"
            @filter-change="filterChange"
            @scroll="scrollCallback"
        ></vxe-grid>

        <pagenator @page-change="handlerPageChange" :query="query" >
        </pagenator>
    </div>

    <summary-detail ref="SummaryDetailRef" :is-min-screen="isMinScreen"/>
    <update-inner-exp-code-dialog ref="UpdateInnerExpCodeDialogRef" @finish="getData"/>
    <update-purchase-code-dialog ref="UpdatePurchaseCodeDialogRef" @finish="getData"/>
    <buy-dialog ref="BuyDialogRef" @finish="getData"/>
    <transport-dialog ref="TransportDialogRef" @finish="getData"/>
    <exp-company-dialog ref="ExpCompanyDialogRef" @finish="getData"/>
    <add-stock-detail-dialog ref="AddStockDetailDialogRef" @finish="getData"/>
    <sync-order ref="SyncOrderRef" :is-min-screen="isMinScreen"/>
    <!-- 快递货物 -->
    <inner-exp-code-dg ref="kuaidiRef" />
    <!--打印-->
    <stock-print :print-ctrls="printCtrls" ref="printDg" @print-finish = "getData"/>
    <!--打印拣货单&自定义快递单-->
    <stock-print4 :print-ctrls="printCtrls" ref="printDg4" />
    <!--自定义快递单-->
    <stock-print6 :print-ctrls="printCtrls" ref="printDg6" />
    <!--物流记录-->
    <stock-trace ref="StockTraceRef" />
    <!--代打包-->
    <stock-pkg-type ref="pkgTypeDg" />
    <!--跨仓合并包-->
    <stock-start-pkg-type ref="startPkgTypeDg" />
    <!--更新sku货号-->
    <sku-update-dialog ref="SkuUpdateDialogRef" @finish="getData"/>
    <!--更新成本-->
    <cost-update-dialog ref="CostUpdateDialogRef" @finish="getData"/>
    <!--快递同步-->
    <sync-express ref="SyncExpressDialogRef" @finish="doSyncExpress"/>

    <!--采购弹窗-->
    <stock-detail-purchase ref="purchasDg" :stocks="selectedStocks" @finish="getData"/>
    
    <view-setting-dialog ref="viewSettingDialogRef"/>

</div>
</template>

<script>

import Pagenator from "../../components/Pagination.vue";
import CtrlBox from "../../components/CtrlBox.vue";
import QueryBox from "../../components/QueryBox.vue";
import OrderColumn from "./OrderColumn.js"
import OrderCtrl from "./OrderCtrl.vue"
import OrderService from "./OrderService.js"
import SummaryDetail from "./SummaryDetail.vue"
import UpdateInnerExpCodeDialog from "./UpdateInnerExpCodeDialog.vue"
import UpdatePurchaseCodeDialog from "./UpdatePurchaseCodeDialog.vue"
import BuyDialog from "./BuyDialog.vue"
import StockStartPkgType from "./StockStartPkgType.vue"
import TransportDialog from "./TransportDialog.vue"
import ExpCompanyDialog from "./ExpCompanyDialog.vue"
import CostUpdateDialog from "./CostUpdateDialog.vue"
import AddStockDetailDialog from "./AddStockDetailDialog.vue"
import SyncOrder from "../store/StockSyncOrder.vue";
import StockPrint from "../store/StockPrint.vue";
import StockPrint4 from "../store/StockPrint4.vue";
import StockPrint6 from "../store/StockPrint6.vue";
import StockTrace from "../store/StockTrace.vue";
import StockPkgType from "../store/StockPkgType.vue";
import InnerExpCodeDg from "../inventory/InnerExpCodeExpress.vue";
import SkuUpdateDialog from "../order/SkuUpdateDialog.vue"
import SyncExpress from "../order/SyncExpress.vue"
import StockDetailPurchase from "../store/StockDetailPurchase.vue";
import axios from "axios";
import {
    batchSendOrderNew,
    trackExpress,
    doUpdatePkgType,
    finishPakage,
    markOrderGoodType,
    openWindowWithPost,
    deleteStock,
} from "../store/StockService.js"
import ViewSettingDialog from '../view/ViewSettingDialog.vue'
import ViewsPop from '../view/ViewsPop.vue'

export default {
    name: 'Order',
    components: {
        Pagenator:Pagenator,
        CtrlBox: CtrlBox,
        QueryBox: QueryBox,
        // ColumnSettings:ColumnSettings,
        SummaryDetail: SummaryDetail,
        UpdateInnerExpCodeDialog: UpdateInnerExpCodeDialog,
        UpdatePurchaseCodeDialog: UpdatePurchaseCodeDialog,
        CostUpdateDialog:CostUpdateDialog,
        BuyDialog: BuyDialog,
        AddStockDetailDialog:AddStockDetailDialog,
        SyncOrder: SyncOrder,
        StockPrint: StockPrint,
        StockPrint4:StockPrint4,
        StockPrint6:StockPrint6,
        StockTrace:StockTrace,
        StockPkgType:StockPkgType,
        InnerExpCodeDg: InnerExpCodeDg,
        OrderCtrl: OrderCtrl,
        SkuUpdateDialog:SkuUpdateDialog,
        StockDetailPurchase:StockDetailPurchase,
        TransportDialog:TransportDialog,
        ExpCompanyDialog:ExpCompanyDialog,
        StockStartPkgType:StockStartPkgType,
        SyncExpress:SyncExpress,
        ViewSettingDialog:ViewSettingDialog,
        ViewsPop:ViewsPop,
    },
    mounted: async function(){
        this.queries = OrderColumn.queries;
        // console.log(this.queries);
        // this.getData();
        this.goodTypeBtns = this.dicts.stockBtns.find(s => s.key== 'markGoodType').children;

    },
    data(){
        return {
            emptyFixedBoxHeight: '37px',
            query: {
                length: 10,
                start: 0,
                pageIndex:1,
                pageTotal: 0,

                code: null, //单号
                orderByType: null, //排序类型见StockDetailListQuery
                status: [],  //待备货、备货中、待打包、已打单、打包中，其中截货中要与其他4个条件相互排斥
                innerExpCode: null, //快递单号
                purchaseStatus: null,  //是否已采购
                isBuyLink: null,  //有/无采购链接
                purchaseCode: null, //采购单号
                sku: null, 
                variationSku: null, //货号
                expCompany: null, //配送方式
                isExpCode: null, //是否有快递单号
                shopName: null, //店铺名
                productSpec: null, //规格
                productTitle: null, //商品标题
                Date: [],
                PurchaseDate: [],
                LastDate: [],
                lockData: false,
                statusStr:null,
                codeType: 0,
                innerExpCodeType: 0,
                purchaseCodeType: 0,
                productTitleType: 0,
                productSpecType: 0,
                skuType: 0,
                variationSkuType: 0,
                shopNameType: 0
            },
            searchTypes: [
                {label: "等于", value: 0},
                {label: "左包含", value: 1},
                {label: "包含", value: 2},
            ],
            selectedStocks: [],
            columns: [],
            datas: [],
            showQuery: false,  //是否显示查询区域
            mergeCells: [],
            printCtrls: [],
            isInventory: false,
            goodTypeBtns: [],
            // selectedRows: [], //刷新之前的选中的数据
            view: null, //当前显示的视图
            queries: null, //查询条件的定义
        }
    },
    directives: {
        reheight: {
            bind(el, binding) {
                let height = '';
                function isReheight() {
                    const style = document.defaultView.getComputedStyle(el);
                    if (height !== style.height) {
                        binding.value(style.height);
                    }
                    height = style.height;
                }
                el.__vueSetInterval__ = setInterval(isReheight, 300);
            },
            unbind(el) {
                clearInterval(el.__vueSetInterval__);
            }
        }
    },
    computed: {
        isMinScreen: {  //是否小屏幕，浏览器
            get() {
                var is = this.$store.state.isMinScreen;
                return is;
            }
        },
        orderInfoWindowId: { //订单详情窗口id
            get() {
                var is = this.$store.state.orderInfoWindowId;
                return is;
            }
        }, 
        docHeight: {  //表格的高度
            get() {
                var height =  this.$store.state.docHeight;
                return height - 260;
            }
        },
        routeTab: {
            get(){
                try{
                    return this.$store.state.activeMenus[this.$route.path]
                }catch{
                    return null;
                }
            }
        }
    },
    methods: {
        //重置查询条件
        reset(){
            this.$kit.clearQuery(this.query);
            this.isInventory = false;
            // this.selectedRows = [];
            this.query.lockData = false;

            // this.query.purchaseCodeType= 0;
            // this.query.innerExpCodeType= 0;
            // this.query.productTitleType= 0;
            // this.query.productSpecType= 0;
            // this.query.skuType= 0;
            // this.query.variationSkuType= 0;
            // this.query.shopNameType= 0;
            if(this.queries){
                this.queries.forEach(q => {
                    this.query[q.field+"Type"] = q.operator;
                })
            }
          
        },
        ctrlBoxHeightChanged(height){
            this.emptyFixedBoxHeight = height;
        },
        //刷新列表字段
        refreshColumn(cols){
            this.columns = OrderColumn.buildColumns(this.$createElement, this, cols)
        },
        doNav(statusStr){
            this.query.statusStr = statusStr;
            if (statusStr == '-1') {
                this.query.status = [];
            }else{
                this.query.status = statusStr.split(',')
                .map(function(item) {
                    return Number(item); // 或者使用加号：return +item;
                });
            }
            
            this.getData(true);
        },
        //获取列表数据
        getData(refresh){

            let param = null;
            if(this.query.lockData){
                param= {
                    ids: this.datas.map(e => e.id),
                    lockData: true,
                };
            }else{
                if(refresh){
                    this.query.pageIndex = 1;
                    this.query.start = 0;
                    // this.selectedRows = [];
                }
                // else{
                //     this.selectedRows = this.$refs.dataTable.getCheckboxRecords();
                // }
                param = this.$kit.rebuildQuery(this.query, ['Date', 'LastDate', 'PurchaseDate']);
            }
            
            if(param.status && param.status.length>0){
                param.status = param.status.join(",")
            }

            this.$axios.post(
                this.$kit.api.stockDetail.listByStock1, 
                param
            ).then((result) => {
                if(result.status){
                    let list = result.data.list;
                    //计算数量，便利每一条数据，然后找到这条数据的所有相同stockId的数据productQty然后求和
                    list.forEach(d => {
                        d['amount'] = (((d.productPrice || 0) * (d.productQty || 0))/100).toFixed(2) 

                        d['qty'] = list.filter(t => t.stockId === d.stockId)
                            .map(t => t.productQty || 0)
                            .reduce((x, y)=> x+y);

                        d['inventory'] = null;
                        d['requestedInventory'] = false;
                        d['taolink'] = null;
                        d['requestedTaolink'] = false;
                    });

                    this.datas = list;
                    this.query.pageTotal = result.data.total;
                    this.$nextTick(() => {

                        // if(this.selectedRows && this.selectedRows.length>0){

                        //     let newSelectedRows = [];
                        //     this.selectedRows.forEach(r => {
                        //         let newRow = this.datas.find(n => r.id == n.id);
                        //         if(newRow){
                        //             newSelectedRows.push(newRow);
                        //         }
                        //     });

                        //     if(newSelectedRows.length>0){
                        //         this.$refs.dataTable.setCheckboxRow(newSelectedRows, true)
                        //     }
                        // }


                        this.getInventory();
                        this.mergeCells = OrderService.mergeRow(this.$refs.dataTable);
                    });
                }else{
                    this.$message(result.msg || this.msg('获取失败'));
                }
            });
        },
        //分页发生变化的回调函数
        handlerPageChange(info){
            this.query.length = info[0];
            this.query.start = info[1];
            // this.selectedRows = [];
            this.getData();
        },
        //点击行，选中行
        clickRow({row,rowIndex, $event, column, columnIndex}){
            let className = $event.target.className;
            if(column.property == "hasLink" && row.hasLink){

                if(row.requestedTaolink){
                    if(row.taolink){
                        this.viewLink(row.taolink);
                    }
                }else{
                    row.requestedTaolink = true;
                    this.$axios.get(
                        this.$kit.api.stockDetail.getPurchseLink+"?purchaseId="+row.purchaseId, 
                    ).then((result) => {
                        if(result.status){
                            let link = result.data;
                            if(link){
                                row.taolink = link;
                                this.viewLink(link);
                            }
                        }else{
                            this.$message(result.msg || this.msg('获取失败'));
                        }
                    });
                }
            }else if(column.property == "status"){
                this.$refs.StockTraceRef.showTracks(row.stockId, 0);
            }else if(column.property == 'code'){  //打开预览详情
                if(className.indexOf('detail-cell')>-1){
                    this.openDetail(row.stockId);
                }
            }
        },
        openDetail(id){
            window.localStorage.setItem("viewDetailIds", id);
            this.$tabs.open("/admin/stock/stock-detail");
        },
        viewLink(link){
            this.$confirm(link, '产品链接：', {
                confirmButtonText: '打开',
                cancelButtonText: '复制产品ID',
                type: 'warning'
            }).then(() => {

                window.open(link, "_blank");

            }).catch(() => {
                // window.navigator.clipboard.writeText(link)
                // 创建一个临时的文本区域
                const tempInput = document.createElement('textarea');
                // 设置要复制的文本内容
                let productId  = link.substring(link.lastIndexOf('/')+1);
                tempInput.value = productId;
                tempInput.style="opacity:0;"
                // 追加到 body 中
                document.body.appendChild(tempInput);
                // 选中文本
                tempInput.select();
                // 执行复制操作
                document.execCommand('copy');
                // 移除临时文本区域
                document.body.removeChild(tempInput);
                this.$message("成功");
            });

        },
        //查询条件，状态选择框的值发生改变的回调函数
        changStatus(values){
            // console.log(values);

            // var status = values[values.length-1];
            // if(status == 80){
            //     // values = values.slice(index, index+1);
            //     this.query.status = [80]
            // }else{
            //     let index = values.indexOf(80);
            //     if(index > -1){
            //         this.query.status = values.filter(v => v!==80)
            //     }
            // }

        },
        scrollCallback(scroll, event) {
            if (scroll.type != 'body' || !scroll.isY) {
                return;
            }
            this.getInventory();
            this.mergeCells = OrderService.mergeRow(this.$refs.dataTable);
        },
        filterChange(event) {
          this.mergeCells = OrderService.mergeRow(this.$refs.dataTable);
        },
        getInventory(){
            // console.log(this.isInventory);
            if(!this.isInventory){
                return;
            }

            var data = this.$refs.dataTable.getTableData();
            var visibleData = data.tableData;

            //页面刚刚初始化完成，无法获取到visiableData,所有默认去总数据里面取10条
            if (visibleData.length <= 1) {
                visibleData = data.visibleData.slice(0, 10);
            }

            let dtos = visibleData.filter(d=>!d.requestedInventory)
                .filter(d => d.sku || d.variationSku)
                .map(d => {
                    let p =  {id: d.id, variationSku: d.variationSku, sku: d.sku, owner: d.owner}
                    return p;
                }); 

            visibleData.forEach(s => s.requestedInventory = true)

            if(dtos && dtos.length>0){
                axios.request({
                    url: this.$kit.api.stockDetail.getInventoryQty, 
                    method: 'post',
                    headers: {"Content-Type":"application/json; charset=utf-8",
                        "X-Requested-With":"XMLHttpRequest",
                    },
                    data: dtos,
                    withCredentials: true,
                }).then((result) => {
                    if(result.data.status){
                        
                        let inventories = result.data.data;
                        visibleData.forEach(vd => {
                            try{
                                let inventory = inventories[vd.id];
                                if(inventory){
                                    this.$set(vd, 'inventory', inventory)
                                    // vd.inventory = inventory;
                                }
                            }catch(err){
                                console.log(err);
                            }
                        })

                    }
                })
            }

        },
        //统计
        doSummary(){
            this.callSelectedMethod(

                (selectes) => {
                    selectes.forEach(s => console.log(s.id))

                    let ss = selectes.filter(s => {
                        let item = this.datas.find(i => i.id == s.id);
                        return item ? true: false
                    });

                    this.$refs.SummaryDetailRef.doSummary(ss);
                }
            );
           
        },
        //采购
        buy(){
            this.callSelectedMethod(
                (selectes) => {
                    //通过sku、货号去匹配采购链接，如果获取到则直接跳转
                    this.selectedStocks = selectes.map(s => {return {stockId: s.stockId, detailId: s.id, qty: s.productQty}});
                    let links = OrderService.concatPurchaseLink(selectes);
                    if(links.length == 1){
                        window.OKK_Orders.openOrderInfo(this.$kit.api.stockDetail.orderInfo+"?id="+selectes[0].id, this.orderInfoWindowId || null, (windowId)=>{
                            this.$store.commit('orderInfoWindowId', windowId);
                        });
                        window.open(links[0], "_blank");
                        this.$refs.purchasDg.showDialog();
                        return;
                    }
                    this.$refs.BuyDialogRef.checkNeedBuy(selectes,false, ()=>{
                        this.$refs.purchasDg.showDialog();
                    });
                }
            );
        },
        //修改链接
        editPurchaseLink(){
            this.callSelectedMethod(
                (selectes) => {
                    this.$refs.BuyDialogRef.checkNeedBuy(selectes, true);
                }
            );
        },
        //更新运输方式
        doUpdateTransport(){
            this.callSelectedMethod(
                (selectes) => {
                    this.$refs.TransportDialogRef.showDialog(selectes, true);
                }
            );
        },
        //更新配送方式
        doUpdateCompany(){
            this.callSelectedMethod(
                (selectes) => {
                    this.$refs.ExpCompanyDialogRef.showDialog(selectes, true);
                }
            );
        },
        //更新快递单号
        updateInnerExpCode(){
            this.callSelectedMethod(
                (selectes) => {
                    this.$refs.UpdateInnerExpCodeDialogRef.showDialog(selectes);
                }
            );
        },
        //更新采购单号
        updatePurchaseCode(){
            this.callSelectedMethod(
                (selectes) => {
                    this.$refs.UpdatePurchaseCodeDialogRef.showDialog(selectes);
                }
            );
        },
        //货单备注/报单备注
        updateRemark(type){
            this.callSelectedMethod(
                (selectes) => {
                    OrderService.updateRemark(type, selectes, this.getData);
                }
            );
        },
        //更新数量
        updateQty(row){
            OrderService.updateQty(row,this.getData);
        },
        //更新成本
        updateCost(row){
            OrderService.updateCost(row,this.getData);
        },
        //新增详情
        addDetail(){
            this.callSelectedMethod(
                (selectes) => {
                    this.$refs.AddStockDetailDialogRef.showDialog(selectes[0]);
                }
            );
        },
        //删除详情
        deleteDetail(){
            this.callSelectedMethod(
                (selectes) => {
                    OrderService.deleteDetail(selectes[0], this.getData)
                }
            );
        },
        //同步订单
        doSyncOrder(){
            this.$refs.SyncOrderRef.showDialog();
        },
        //打印
        doPrint(cmd){
            this.callSelectedMethod(
                (selectes) => {
                    this.$confirm(this.msg('是否要执行打印？'), this.msg('提示'), {
                        confirmButtonText: '确定',
                        cancelButtonText: '取消',
                        type: 'warning'
                    }).then(() => {
                        if(cmd == 1){
                            this.printCtrls = [1]
                            this.$refs.printDg.preparePrint(selectes.map(s=>s.stockId), this.printCtrls);
                        }else if(cmd == 2){
                            this.printCtrls = [0];
                            this.$refs.printDg.preparePrint(selectes.map(s=>s.stockId), this.printCtrls);
                        }else if(cmd == 3){
                            this.printCtrls = [1];
                            this.$refs.printDg6.preparePrint(selectes.map(s=>s.stockId), this.printCtrls);
                        }else if(cmd == 4){
                            this.printCtrls = [1];
                            this.$refs.printDg4.preparePrint(selectes.map(s=>s.stockId), this.printCtrls);
                        }
                    }).catch((err) => {
                        // console.log(err);
                    })
                }
            );

        },
        //一键发货
        doBatchSendOrderNew(){
            this.callSelectedMethod(
                (selectes) => {
                    batchSendOrderNew(selectes.map(e => e.stockId));

                }
            );
        },
        //快递同步
        doTrackExpress(){
            this.$refs.SyncExpressDialogRef.showDialog();
        },
        doSyncExpress(){
            this.callSelectedMethod(
                (selectes) => {
                    trackExpress(selectes.map(e => e.stockId), this.getData)
                }
            );
        },
        //删除国内快递单号
        doDeleteInnerCode(){
            this.callSelectedMethod(
                (selectes) => {
                    OrderService.deleteInnerCode(
                        selectes.map(e => e.id),
                        this.getData
                    );
                }
            );
        },
        //删除采购单号
        doDeletePurchase(){
            this.callSelectedMethod(
                (selectes) => {
                    OrderService.rebackPurchaseCode(
                        selectes.map(e => e.id),
                        this.getData
                    );
                }
            );
        },
        selectStock(){//货物转寄
            this.callSelectedMethod(
                (selectes) => {
                    // this.$tabs.open("/admin/stock/match?ids="+selectes.map(e => e.stockId).join(","));
                    this.$router.push({ name: 'stockMatch', params: {ids: selectes.map(e => e.stockId)}});
                }
            );
        },
        //代打包
        handlePkgType(command){

            this.callSelectedMethod(
                (selectes) => {
                    let ids = selectes.map( o => o.stockId);
                    // console.log(command);
                    if(command == 'a'){
                        doUpdatePkgType(1, ids, ()=> {
                            this.$refs.pkgTypeDg.showDialog(ids.join(","), ()=>{
                                this.getData(false);
                            });
                        });
                    }else if(command == 'b'){
                        //跨仓合并包
                        doUpdatePkgType(2, ids, ()=> {
                            this.$refs.startPkgTypeDg.showDialog(ids.join(","), ()=>{
                                this.getData(false);
                            });
                            // this.getData(false);
                        });
                    }
                }
            );
        },
        changeOrderPlatform(){  //将订单卖场改为虾皮离线
            this.callSelectedMethod(
                (selectes) => {
                    this.$confirm(this.msg('是否要将订单从订单管理永久移除？'), this.msg('提示'), {
                        confirmButtonText: '确定',
                        cancelButtonText: '取消',
                        type: 'warning'
                    }).then(() => {
                        this.$axios.post(this.$kit.api.stock.changeOrderPlatform
                            +"?ids="+selectes.map(e => e.stockId).join(",")
                        ).then((result) => {
                            if(result.data){
                                this.$message(result.msg+":"+result.data.join(","));
                                this.getData(false);
                            }else{
                                this.$message(result.msg);
                            }
                        })
                    }).catch((err) => {
                        // console.log(err);
                    })
                }
            );
        },
        doFinishPakage(){//打包完成
            this.callSelectedMethod(
                (selectes) => {
                    finishPakage(selectes.map(s => s.stockId), ()=>{this.getData(false)});
                }
            );
        },
        //更新货物普特货类型
        doMarkOrderGoodType(command){
            this.callSelectedMethod(
                (selectes) => {
                     markOrderGoodType(command, selectes.map(s => s.stockId), ()=>{this.getData(false)});
                }
            );
        },
        //更新成本
        doUpdateCost(){
            this.callSelectedMethod(
                (selectes) => {
                    this.$refs.CostUpdateDialogRef.showDialog( selectes.map(s => s.id).join(","));
                }
            );
        },
        //快递货物
        kuaidi(){
            this.$refs.kuaidiRef.showDialog();
        },
        //导出采购详情
        exportDetail(){
            this.callSelectedMethod(
                (selectes) => {
                    openWindowWithPost(this.$kit.api.export.exportBuyDetail,{ids: selectes.map(s => s.stockId), history:0 });
                }
            );
        },
        //删除订单
        doDeleteStock(){
            this.callSelectedMethod(
                (selectes) => {
                    deleteStock(selectes.map(s=>s.stockId).join(","), this.getData);
                }
            );
        },
        //确认取消
        doCancelStock(){
            var selectes = this.$refs.dataTable.getCheckboxRecords();
            if(selectes.length==0){
                this.$message(this.msg('请选中一条数据进行操作'));
                return;
            }
            let item = 2;
            var _this = this;
            this.$axios.post(_this.$kit.api.stock.getStockByIds,selectes.map(e => e.stockId).join(","))
                .then((result) => {
                    let data = result.data;
                    for(let i=0;i<data.length;i++){
                        let e = data[i];
                        if(e.expPageStatus >= 15 && e.status != 80 && e.status != 79){
                            this.$message(e.code+this.msg('面单已打印,不能取消订单'));
                            return;
                        }
                        if(e.isCancel == 2 && item == 2){
                            _this.$message(e.code+this.msg('已取消，不能进行操作'));
                            return;
                        }
                        if(e.isCancel == 0 && item == 0){
                            _this.$message(e.code+this.msg('未取消订单不能恢复'));
                            return;
                        }
                    }

                    let msg = '';
                    if(item == 2){
                        msg = this.msg('确定要取消所选订单吗?');
                    }else{
                        msg = this.msg('确定要恢复所选订单吗?');
                    }
                    this.$confirm(msg, this.msg('提示'), {
                        confirmButtonText: this.msg('确定'),
                        cancelButtonText: this.msg('取消'),
                        type: 'warning'
                    }).then(() => {
                        _this.$axios.post(_this.$kit.api.updateColumn.updateCancel+'?value='+item+'&type=1',selectes.map(e => e.stockId).join(","))
                        .then((result) => {
                            if(result.status){
                                _this.$message(result.msg || _this.msg('更新成功'));
                                _this.getData;
                            }else{
                                _this.$message(result.msg || _this.msg('更新失败'));
                            }
                        });
                    }).catch((err) => {
                        _this.$message(_this.msg('取消操作'));
                    });
                })
        },
        //更新sku和货号
        updateSku(){
            this.callSelectedMethod(
                (selectes) => {
                    let sku = {
                        variationSku: null,
                        sku: null,
                    }

                    this.$refs.SkuUpdateDialogRef.showDialog(sku, selectes.map(s=>s.stockId).join(","), selectes.map(s => s.id).join(","), 1);
                }
            );
        },
        callSelectedMethod(callMethod){
            var selectes = this.$refs.dataTable.getCheckboxRecords();
            if(selectes.length==0){
                this.$message(this.msg('请选中一条数据进行操作'));
                return;
            }else{
                callMethod(selectes);
            }
        },
        showViewSetting(){
            this.$refs.viewSettingDialogRef.showDialog(
                "1",
                this.view,
                OrderColumn.allColumns,
                OrderColumn.queries,
                this.dicts.filterOrderOptionTypes
            );
        },
        viewChange(view){
            // console.log(view);
            this.view = view;
            this.columns = OrderColumn.buildColumns(this.$createElement, this, this.view? this.view.columns: null);
            if(this.view){
                this.queries = this.view.queries;
            }else{
                this.queries = OrderColumn.queries;
            }
            this.queries.forEach(e => {
                this.buildQueryDefaultValue(e);
            })
            this.getData();
        },
        //构建查询条件的一些信息
        buildQueryDefaultValue(q){
            if(q.type == 'input'){
                //设置查询类型
                // console.log(q.field);
                this.query[q.field+"Type"] = q.operator;

                if(!q.defaultValue) {
                    return "";
                }

                this.query[q.field] = q.defaultValue;

            }else {
                if(!q.defaultValue) {
                    return "";
                }

                if(q.type == "selector"){
                    this.query[q.field] = q.defaultValue;
                }else if(q.type == 'selectors'){
                    let values = q.defaultValue.split(",");
                    if(q.field == 'status'){
                        values = values.map(s => s*1);
                    }
                    this.query[q.field] = values;
                }else if(q.type == 'daterange'){ //3-表示是时间类型
                    let curr = new Date();
                    let prevTime =  curr.getTime() - (q.defaultValue * 24 * 3600 * 1000);
                    let prev;
                    if(q.defaultValue == 1){
                        prev = curr;
                    }else{
                        prev = new Date(prevTime);
                    }
                    let nv = [this.$kit.fmtDate(prev), this.$kit.fmtDate(curr)];
                    this.query[q.field] = nv;
                }else if(q.type == 'datetimerange'){//日期时间类型
                    let curr = new Date();
                    let prevTime =  curr.getTime() - (q.defaultValue * 24 * 3600 * 1000);
                    let prev = new Date(prevTime);
                    let nv =  [this.$kit.fmtDateTime(prev), this.$kit.fmtDateTime(curr)];
                    this.query[q.field] = nv;
                }
            } 

            return "";
        }
    }

}

</script>

<style lang="scss" scoped>
.data-table::v-deep(.vxe-table--render-default .vxe-body--column.col--ellipsis>.vxe-cell,
.vxe-table--render-default .vxe-footer--column.col--ellipsis>.vxe-cell,
.vxe-table--render-default .vxe-header--column.col--ellipsis>.vxe-cell){
    max-height:none;
}
.detail-cell{cursor:pointer; display:inline-block; margin-right:5px;}
.page-box{overflow-y:auto;}
.ctrl-box{position: absolute;z-index:99;width:100%;}
.empty-fixed-box{height:57.5px;}
.auto-break{
    word-break: break-all;
    white-space: pre-line;
}
.ctrl-item{
    display:block;
}
.ctrl-item::v-deep(.el-link--inner){
    display:flex;
    align-items: center;
}

.multi-line-ellipsis {
    display: -webkit-box;
    -webkit-box-orient: vertical;
    -webkit-line-clamp: 3; /* 限制在一个块元素显示的文本的行数 */
    overflow: hidden;
    text-overflow: ellipsis;
    line-height: 1.2em; /* 可以设为任意值，根据实际需要调整 */
    max-height: 3.6em; /* 根据行高计算出的最大高度，用于多行显示 */
}
.nav-tag span{
  margin:0px 10px 5px 0px;
  cursor: pointer;
}
</style>